import { render, staticRenderFns } from "./Pagos.vue?vue&type=template&id=fb87e1f8&scoped=true"
import script from "./Pagos.vue?vue&type=script&lang=js"
export * from "./Pagos.vue?vue&type=script&lang=js"
import style0 from "./Pagos.vue?vue&type=style&index=0&id=fb87e1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb87e1f8",
  null
  
)

export default component.exports